import React from 'react';
import { withRouter } from 'react-router-dom';
import { View } from 'react-native';
import Header from '../../components/Header/Header.web';
import DiscoverMapScreen from '../DiscoverMap/DiscoverMapScreen';

function PublicDiscover(props) {
  return (
    <View style={{ flex: 1 }}>
      <Header />
      <DiscoverMapScreen
        isPublicSite
        region={
          props.location && props.location.state && props.location.state.region
        }
      />
    </View>
  );
}

export default withRouter(PublicDiscover);
